// src/services/api.js
import {
  FALLBACK_PERSONS_WITH_DAYS,
  FALLBACK_STATS,
} from './fallbackData';

const BASE_URL = 'https://backendbuscarpersonas-production.up.railway.app';
const TIMEOUT  = 6000; // 6 segundos antes de usar fallback

// ── Fetch con timeout ─────────────────────────────────────────────────────────
const fetchWithTimeout = (url, options = {}) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT);
  return fetch(url, { ...options, signal: controller.signal })
    .finally(() => clearTimeout(timer));
};

const get = async (path) => {
  const res = await fetchWithTimeout(`${BASE_URL}${path}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

const post = async (path, body) => {
  const res = await fetchWithTimeout(`${BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
};

// ── Helpers de fallback local ─────────────────────────────────────────────────
const filterPersons = (params = '') => {
  const url    = new URLSearchParams(params.replace('?', ''));
  const status = url.get('status')?.toUpperCase();
  const search = url.get('search')?.toLowerCase();
  const limit  = parseInt(url.get('limit') || '50');
  const offset = parseInt(url.get('offset') || '0');

  let list = [...FALLBACK_PERSONS_WITH_DAYS];

  if (status) list = list.filter(p => p.status === status);
  if (search) list = list.filter(p =>
    p.name.toLowerCase().includes(search) ||
    p.location.toLowerCase().includes(search) ||
    (p.caseId && p.caseId.toLowerCase().includes(search))
  );

  return {
    persons: list.slice(offset, offset + limit),
    total:   list.length,
    _offline: true,
  };
};

// ── API con fallback automático ───────────────────────────────────────────────
export const getPersons = async (params = '') => {
  try {
    return await get(`/api/persons${params}`);
  } catch {
    console.warn('[VuelveACasa] Servidor no disponible — usando datos locales');
    return filterPersons(params);
  }
};

export const getPersonById = async (id) => {
  try {
    return await get(`/api/persons/${id}`);
  } catch {
    const person = FALLBACK_PERSONS_WITH_DAYS.find(p => p.id === id);
    if (person) return person;
    throw new Error('Caso no encontrado');
  }
};

export const getStats = async () => {
  try {
    return await get('/api/stats');
  } catch {
    return FALLBACK_STATS;
  }
};

export const getAlerts = async () => {
  try {
    return await get('/api/alerts');
  } catch {
    return [];
  }
};

// Estas no tienen fallback local — solo funcionan con servidor activo
export const reportPerson = (data) => post('/api/persons', data);
export const sendTip      = (data) => post('/api/tips', data);
export const shareCase    = (id)   => post(`/api/persons/${id}/share`, {}).catch(() => {});
